function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getComposeEntryProps } from './composePage.js';
import { getEntryProps } from '../utils/getEntryProps.js';
const GLOBAL_NAV_LINK_CONTENT_MODEL_ID = 'cdxGlobalNavLink';

/**
 * To be used only with Settings models (e.g. navbar, footer)
 */

const getUrl = (url, navLink, options) => {
  if (!navLink) return url;
  if (!navLink.fields) {
    // If fields are empty, it means the current page is the composePage (by circular ref), so the url should point to the current URL.
    return '';
  }
  const _getComposeEntryProps = getComposeEntryProps(navLink),
    composeSlug = _getComposeEntryProps.composeSlug;
  return options?.subPath && options?.appendCurrentSubpathToUrl ? `${options.subPath}/${composeSlug}` : `${url ? `${url}/` : ''}${composeSlug}`.replace('//', '/');
};
const mapEntryLink = entry => {
  const _getEntryProps = getEntryProps(entry),
    _getEntryProps$label = _getEntryProps.label,
    label = _getEntryProps$label === void 0 ? '' : _getEntryProps$label,
    _getEntryProps$url = _getEntryProps.url,
    url = _getEntryProps$url === void 0 ? '' : _getEntryProps$url,
    _getEntryProps$urlLab = _getEntryProps.urlLabel,
    urlLabel = _getEntryProps$urlLab === void 0 ? '' : _getEntryProps$urlLab,
    navLinkContent = _getEntryProps.composePage,
    subPath = _getEntryProps.subPath,
    appendCurrentSubpathToUrl = _getEntryProps.appendCurrentSubpathToUrl;
  return {
    url: getUrl(url, navLinkContent, {
      subPath,
      appendCurrentSubpathToUrl
    }),
    label,
    urlLabel
  };
};
const mapSettingNavLink = entry => {
  const linkProps = mapEntryLink(entry);
  const _getEntryProps2 = getEntryProps(entry),
    description = _getEntryProps2.description,
    icon = _getEntryProps2.icon;
  return _objectSpread(_objectSpread({}, linkProps), {}, {
    description,
    icon: icon?.fields.file.url
  });
};
const mapLinkGroup = linkGroupEntry => {
  const _getEntryProps3 = getEntryProps(linkGroupEntry),
    _getEntryProps3$categ = _getEntryProps3.category,
    category = _getEntryProps3$categ === void 0 ? '' : _getEntryProps3$categ,
    _getEntryProps3$links = _getEntryProps3.links,
    links = _getEntryProps3$links === void 0 ? [] : _getEntryProps3$links;
  return {
    category,
    links: links?.map(mapEntryLink)
  };
};
export { GLOBAL_NAV_LINK_CONTENT_MODEL_ID, mapEntryLink, mapLinkGroup, mapSettingNavLink };
//# sourceMappingURL=navlink.js.map
